// extracted by mini-css-extract-plugin
export default {"container":"TableNoRecord-module_container__tRZEPy"};